import { GET_APP_UPDATE_CONTENT, APP_UPDATE_CONTENT_SUCCESS, APP_UPDATE_CONTENT_ERROR } from '../../constants';
export function getAppUpdateContentAction(payload) {
    return {
        type: GET_APP_UPDATE_CONTENT,
        payload,
    };
}
export function appUpdateContentSuccess(result) {
    return {
        type: APP_UPDATE_CONTENT_SUCCESS,
        response: result,
    };
}
export function appUpdateContentError() {
    return {
        type: APP_UPDATE_CONTENT_ERROR,
    };
}
